(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cf-home-shell"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('cf-shopping-home');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const strings = JSON.parse(root.querySelector('[data-cf-strings]').textContent);
  const status = root.querySelector('[data-cart-status]');
  let busy = false;

  function initializeForms(scope = root) {
    scope.querySelectorAll('.cf-product-form').forEach(form => {
      if (form.dataset.enhanced) return;
      form.dataset.enhanced = 'true';
      form.noValidate = true;
      const options = form.querySelector('.cf-options');
      if (options) options.hidden = true;
      const price = form.closest('.cf-product').querySelector('[data-price]');
      price.dataset.originalPrice = price.textContent.trim();
    });
  }

  // Site header cart UI (Dawn cart-notification or cart-drawer) — the same one product pages use.
  const headerCart = () => document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  function headerCartSections() {
    const ui = headerCart();
    if (!ui || typeof ui.getSectionsToRender !== 'function' || typeof ui.renderContents !== 'function') return [];
    return ui.getSectionsToRender().map(section => section.id);
  }

  async function refreshBubble() {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const url = new URL(root.dataset.rootUrl, window.location.origin);
    url.searchParams.set('sections', 'cart-icon-bubble');
    const response = await fetch(url, { cache: 'no-store', signal: AbortSignal.timeout(15000) });
    if (!response.ok) throw new Error(strings.error);
    const html = (await response.json())['cart-icon-bubble'];
    if (!html) throw new Error(strings.error);
    const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    bubble.innerHTML = section ? section.innerHTML : html;
  }

  function setBusy(active) {
    busy = active;
    root.querySelectorAll('.cf-product-form button[type="submit"]').forEach(button => {
      if (active) {
        button.dataset.wasDisabled = String(button.disabled);
        button.disabled = true;
      } else {
        button.disabled = button.dataset.wasDisabled === 'true' || button.dataset.uncertain === 'true';
        delete button.dataset.wasDisabled;
      }
    });
  }

  root.addEventListener('change', event => {
    const select = event.target.closest('.cf-product-form select[name="id"]');
    if (!select) return;
    const selected = select.selectedOptions[0];
    if (selected?.dataset.price) select.closest('.cf-product').querySelector('[data-price]').textContent = selected.dataset.price;
  });

  root.addEventListener('submit', async event => {
    const form = event.target.closest('.cf-product-form');
    if (!form) return;
    event.preventDefault();
    if (busy) return;
    const options = form.querySelector('.cf-options');
    const select = form.querySelector('select[name="id"]');
    if (options?.hidden) {
      options.hidden = false;
      select.focus();
      return;
    }
    if (!form.reportValidity()) return;
    const button = form.querySelector('button[type="submit"]');
    if (button.dataset.uncertain) return;
    const error = form.querySelector('.cf-form-error');
    const cartLink = form.querySelector('.cf-error-cart');
    error.hidden = true;
    cartLink.hidden = true;
    setBusy(true);
    form.setAttribute('aria-busy', 'true');
    button.textContent = strings.adding;
    const data = new FormData(form);
    const cartSectionIds = headerCartSections();
    data.set('sections', cartSectionIds.length ? cartSectionIds.join(',') : 'cart-icon-bubble');
    data.set('sections_url', window.location.pathname);
    let confirmed = false;
    let rejected = false;
    try {
      const response = await fetch(`${root.dataset.addUrl}.js`, {
        method: 'POST', headers: { 'Accept': 'application/json' }, body: data,
        signal: AbortSignal.timeout(15000)
      });
      const result = await response.json().catch(() => { throw new Error(strings.error); });
      if (!response.ok) {
        rejected = true;
        try { await refreshBubble(); } catch {}
        throw new Error(result.description || result.message || strings.error);
      }
      confirmed = true;
      button.textContent = strings.added;
      const name = form.closest('.cf-product').querySelector('.cf-product-title');
      if (status) status.textContent = `${name ? name.textContent.replace(/\s+/g, ' ').trim() : ''}: ${strings.added}`;
      if (select) { select.value = ''; options.hidden = true; }
      const price = form.closest('.cf-product').querySelector('[data-price]');
      price.textContent = price.dataset.originalPrice;
      try {
        const ui = headerCart();
        if (ui && cartSectionIds.length && result.sections) {
          if (typeof ui.setActiveElement === 'function') ui.setActiveElement(button);
          ui.renderContents(result);
        } else {
          await refreshBubble();
        }
      } catch {
        error.textContent = strings.refresh;
        error.hidden = false;
        cartLink.hidden = false;
      }
    } catch (failure) {
      error.textContent = rejected ? failure.message : strings.uncertain;
      error.hidden = false;
      cartLink.hidden = false;
      if (!rejected) button.dataset.uncertain = 'true';
      button.textContent = strings.add;
    } finally {
      setBusy(false);
      form.removeAttribute('aria-busy');
      if (confirmed) window.setTimeout(() => {
        if (!form.hasAttribute('aria-busy')) button.textContent = strings.add;
      }, 1800);
    }
  });

  document.addEventListener('shopify:section:load', event => initializeForms(event.target));
  window.addEventListener('pageshow', event => {
    if (event.persisted) refreshBubble().catch(() => {});
  });
  initializeForms();
})();
  } catch(e) { console.error(e); }
})();

})();
